<template>
  <ak-bulk-actions :display="automations.length > 0">
    <template #head>
      <strong>{{ automations.length }} {{ $t('Selected') }}</strong>
    </template>
    <template #body>
      <ak-button
        id="setEnabled"
        size="small"
        @click.stop.prevent="confirm('enable')"
      >
        {{ $t('Set Enabled') }}
      </ak-button>
      <ak-button
        id="setDisabled"
        size="small"
        class="ml-small"
        color="warning"
        @click.stop.prevent="confirm('disable')"
      >
        {{ $t('Set Disabled') }}
      </ak-button>
      <ak-button
        id="delete"
        size="small"
        class="ml-small"
        color="danger"
        @click.stop.prevent="confirm('delete')"
      >
        {{ $t('Delete') }}
      </ak-button>
    </template>
  </ak-bulk-actions>
</template>

<script>
import { defineComponent, inject } from 'vue'
import BulkActions from '@akerolabs/akero-vue/src/components/bulkActions/BulkActions.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { DialogProgrammatic } from '@akerolabs/akero-vue/src/components/dialog'
import { success, error } from '../utils'
export default defineComponent({
  name: 'BulkActions',
  components: {
    [BulkActions.name]: BulkActions,
    [Button.name]: Button,
  },
  props: {
    /**
     * @type {Array}
     * @description Array of the currently selected automations to run bulk actions on
     */
    automations: {
      type: Array,
      default: () => [],
    },
    /**
     * @type {String}
     * @description The current active account id
     */
    accountId: {
      type: String,
      default: undefined,
    },
    /**
     * @type {String}
     * @description The current active agency id
     */
    agencyId: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    /**
     * @description Inject the fetch automations function from `AutomationList.vue`
     */
    const fetchAutomations = inject('fetchAutomations')
    const fetchStats = inject('fetchStats')

    /**
     * @param {String} action The bulk action to run
     * @description Open a modal to confirm bulk actions and run api request on confirmation
     */
    const confirm = (action) => {
      DialogProgrammatic.confirm({
        title: 'Are you sure?',
        message: 'Are you sure you want to perform this action?',
        cancelText: 'Cancel',
        confirmText: 'OK',
        type: 'primary',
        onConfirm: async () => {
          await bulkRequest(action)
          await fetchAutomations()
          await fetchStats()
        },
      })
    }

    /**
     * @param {String} action The bulk action to run
     * @description Make and api request to run bulk actions
     */
    const bulkRequest = async (action) => {
      const ids = props.automations.map((i) => i._id)
      try {
        await request.post(`/tasks/bulk/${action}`, {
          ids,
          account: props.accountId,
          agency: props.agencyId,
        })
        success('Workflows updated successfully')
      } catch (ex) {
        error(`Unable to ${action} workflows`, ex)
      }
    }

    return {
      confirm,
      bulkRequest,
    }
  },
})
</script>

<i18n>
{
  "en": {
    "Selected": "Selected",
    "Set Enabled": "Set Enabled",
    "Set Disabled": "Set Disabled",
    "Delete": "Delete"
  },
  "en-US": {
    "Selected": "Selected",
    "Set Enabled": "Set Enabled",
    "Set Disabled": "Set Disabled",
    "Delete": "Delete"
  }
}
</i18n>
